module.exports = __webpack_public_path__ + "static/media/Desafio5-c.69040322.mp4";